import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2IssueAttachment } from '@/api/model/interfaces';

export default class PackageKS2IssueAttachmentOdata extends OdataManager<PackageKS2IssueAttachment> {}
